import React from 'react';
import Sidebar from './Sidebar';

export default function DeliveryPage() {
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-white md:px-6 lg:px-10 max-w-7xl">
      <Sidebar />
      <div className="flex-1 p-4 lg:p-8">
        <h1 className="text-3xl md:text-5xl leading-14 font-axi-bold my-5">
          Tarne
        </h1>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          DPD pakiautomaat 1.60 €
        </h2>
        <p className="text-base leading-6 mx-0 my-2">
          Tellimus jõuab Teie valitud pakiautomaati 7 tööpäeva jooksul peale
          tellimuse tasumist.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Tellimuse kohalejõudmisest teavitatakse Teid SMS-teatega.
        </p>
        <p className="text-base leading-6 mx-0 my-2">SMS sisaldab:</p>
        <ul className="list-disc ml-8 mr-0 mt-0 mb-5">
          <li className="text-base leading-6 mx-0 my-2">
            pakiautomaadi ukse avamise koodi;
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            pakiautomaadi asukohta.
          </li>
        </ul>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          Omniva pakiautomaat 1.90 €
        </h2>
        <p className="text-base leading-6 mx-0 my-2">
          Tellimus jõuab Teie valitud pakiautomaati 7 tööpäeva jooksul peale
          tellimuse tasumist.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Tellimuse kohalejõudmisest teavitatakse Teid SMS-teatega.
        </p>
        <p className="text-base leading-6 mx-0 my-2">SMS sisaldab:</p>
        <ul className="list-disc ml-8 mr-0 mt-0 mb-5">
          <li className="text-base leading-6 mx-0 my-2">
            pakiautomaadi ukse avamise koodi;
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            pakiautomaadi asukohta;
          </li>
          <li className="text-base leading-6 mx-0 my-2">hoiutähtaja lõppu;</li>
          <li className="text-base leading-6 mx-0 my-2">tagastuskoodi.</li>
        </ul>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          Omniva kuller 3.90 €
        </h2>
        <p className="text-base leading-6 mx-0 my-2">
          *välja arvatud rattad, suusad ja kelgud, millele lisandub
          kohaletoimetamise tasu 15 €
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Tellimus tuuakse kulleriga Teie poolt valitud aadressile 7 tööpäeva
          jooksul peale tellimuse tasumist.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Kuller võtab teiega telefoni teel ühendust ning kooskõlastab
          kohaletoimetamiseks sobiva aja.
        </p>
      </div>
    </div>
  );
}
